import { ImageCDNPath } from "GlobalConstant/";
const IMAGES_WITH_MAKE_MODEL_ENDPOINT =
  "/:makeMaskingName(.+)-cars/:modelMaskingName([a-zA-Z0-9_-]+)/images/";

const IMAGES_WITH_MAKE_MODEL_IMAGE_NAME_ENDPOINT =
  IMAGES_WITH_MAKE_MODEL_ENDPOINT +
  ":imageName([a-zA-Z0-9_-]+)-:imageId([0-9]+)/";
const COLORS_WITH_MAKE_MODEL_ENDPOINT =
  "/:makeMaskingName(.+)-cars/:modelMaskingName([a-zA-Z0-9_-]+)/colours/";

const COLORS_WITH_MAKE_MODEL_VIDEO_NAME_ENDPOINT =
  COLORS_WITH_MAKE_MODEL_ENDPOINT +
  ":imageName([a-zA-Z0-9_-]+)-:imageId([0-9]+)/";

export const IMAGES_ENDPOINTS = [
  IMAGES_WITH_MAKE_MODEL_ENDPOINT,
  IMAGES_WITH_MAKE_MODEL_IMAGE_NAME_ENDPOINT,
];
export const COLORS_ENDPOINTS = [
  COLORS_WITH_MAKE_MODEL_ENDPOINT,
  COLORS_WITH_MAKE_MODEL_VIDEO_NAME_ENDPOINT,
];

export const PAGE_TYPE = {
  IMAGES: "IMAGES",
  COLORS: "COLORS",
};

export const MARUTI_MAKE_ID = 10;
export const AD_CONFIGURATION = {
  adId: "div-gpt-ad-1516616442657-1",
  adPath: "/1017752/Carwale_Mobile_InImage_Details_320x50",
  adSizes: [
    [320, 50],
    [320, 100],
    [300, 100],
    [300, 150],
    [320, 150],
  ],
};

export const DESKTOP_AD_CONFIGURATION = {
  id: "div-gpt-ad-1516616845209-2",
  path: "/1017752/Carwale_Image_Details_970x90",
  size: [
    [960, 90],
    [970, 66],
    [970, 60],
    [728, 90],
    [960, 66],
    [970, 90],
  ],
};

export const DESKTOP_AD_MIDDLE_CONFIGURATION = {
  id: "div-gpt-ad-1516616442657-0",
  path: "/1017752/Carwale_Image_Details_BTF_970X90",
  size: [
    [960, 90],
    [970, 66],
    [970, 60],
    [728, 90],
    [960, 66],
    [970, 90],
    [930, 180],
    [970, 250],
    [980, 120],
  ],
};

export const IMAGES_MIDDLE_AD_MSITE = {
  id: "'div-gpt-ad-1603784667742-0",
  path: "/1017752/Carwale_mobile_imagelisting_modelspecific_320x100",
  size: [
    [320, 100],
    [336, 280],
    [320, 150],
    [320, 250],
    [300, 150],
    [300, 100],
    [300, 250],
    [320, 50],
  ],
};

export const COLORS_MIDDLE_AD_MSITE = {
  id: "div-gpt-ad-1603784754161-0",
  path: "/1017752/Carwale_mobile_colourpage_320x100_300x250",
  size: [
    [320, 50],
    [300, 250],
    [336, 280],
    [320, 250],
    [300, 100],
    [300, 150],
    [320, 100],
    [320, 150],
  ],
};

export const INTERIOR_QUERY_STRING = "interior";
export const EXTERIOR_QUERY_STRING = "exterior";

export const CATEGORY_ID_MAP = {
  [INTERIOR_QUERY_STRING]: 1,
  [EXTERIOR_QUERY_STRING]: 2,
};

export const PAGE_TAB = {
  ALL: "ALL",
  INTERIOR: "INTERIOR",
  EXTERIOR: "EXTERIOR",
  COLOURS: "COLOURS",
};

export const RECENT_SEARCHES_ROOT_MARGIN = "0px 0px 200px 0px";
export const DESKTOP_ADSLOT = {
  THRID_AD: {
    id: "div-gpt-ad-1597398968302-0",
    path: "/1017752/Carwale_DSK_ImageDetails_Bottom_300x250",
    size: [
      [300, 600],
      [300, 250],
    ],
  },
};

export const YOUTUBE_ICON_IMAGE = `${ImageCDNPath}0x0/cw/static/360icons/video-icon-72x53.png`;
export const THREE_SIXTY_ICON_IMAGE = `${ImageCDNPath}0x0/cw/static/icons/fff/360-68x45.png`;
export const IMAGE_DETAIL_PAGE_NAME = "ImageDetails";

export const IMAGE_CTA_TEXT = "Get Offers";
